import { Box } from '@workos-inc/design-system';
export const QuickNavContainer = ({
  children
}: React.PropsWithChildren) => <div data-algolia-exclude className="QuickNavContainer" data-sentry-component="QuickNavContainer" data-sentry-source-file="quick-nav-container.tsx">
    <div className="QuickNavContainerSticky">
      <div className="QuickNavContainerScroll">
        <Box my="7" data-sentry-element="Box" data-sentry-source-file="quick-nav-container.tsx">{children}</Box>
      </div>
    </div>
  </div>;